import {APP_INITIALIZER, Provider} from '@angular/core';
import {LoggerPort} from '@platform/logger/domain/ports/logger.port';
import {Logger} from "@core/interfaces/Logger";
import {RxEventBusAdapter} from "@platform/event-bus/infrastructure/adapters/rx-event-bus.adapter";
import {EventBusPort} from "@platform/event-bus/domain/ports/event-bus.port";
import {
  PlatformOnAccountResetSubscriber
} from "@platform/event-bus/application/subscribers/platform-on-account-reset.subscriber";
import {
  PlatformOnWalletRemovedSubscriber
} from "@platform/event-bus/application/subscribers/platform-on-wallet-removed.subscriber";
import {
  PlatformOnAccountEntriesAppliedSubscriber
} from "@platform/event-bus/application/subscribers/platform-on-account-entries-applied.subscriber";
import {
  PlatformOnCartOrderSettledSubscriber
} from "@platform/event-bus/application/subscribers/platform-on-cart-order-settled.subscriber";
import {
  PlatformOnAccountSelectedSubscriber
} from "@platform/event-bus/application/subscribers/platform-on-account-selected.subscriber";
import {
  PlatformOnCurrentWaiterUpdatedSubscriber
} from "@platform/event-bus/application/subscribers/platform-on-current-waiter-updated.subscriber";
import {
  PlatformOnServiceSelectionSubscriber
} from "@platform/event-bus/application/subscribers/platform-on-service-selection.subscriber";
import {
  PlatformOnServiceFinaliceSubscriber
} from "@platform/event-bus/application/subscribers/platform-on-service-finalice.subscriber";

export const PLATFORM_SUBSCRIBERS = Symbol('PLATFORM_SUBSCRIBERS');

export const PLATFORM_PROVIDERS: Provider[] = [
  {
    provide: PLATFORM_SUBSCRIBERS,
    useClass: PlatformOnServiceSelectionSubscriber,
    multi: true
  },
  {
    provide: PLATFORM_SUBSCRIBERS,
    useClass: PlatformOnServiceFinaliceSubscriber,
    multi: true
  },
  {
    provide: LoggerPort,
    useExisting: Logger
  },
  {
    provide: EventBusPort,
    useClass: RxEventBusAdapter
  },
  {
    provide: PLATFORM_SUBSCRIBERS,
    useClass: PlatformOnAccountResetSubscriber,
    multi: true
  },
  {
    provide: PLATFORM_SUBSCRIBERS,
    useClass: PlatformOnWalletRemovedSubscriber,
    multi: true
  },
  {
    provide: PLATFORM_SUBSCRIBERS,
    useClass: PlatformOnAccountEntriesAppliedSubscriber,
    multi: true
  },
  {
    provide: PLATFORM_SUBSCRIBERS,
    useClass: PlatformOnAccountResetSubscriber,
    multi: true
  },
  {
    provide: PLATFORM_SUBSCRIBERS,
    useClass: PlatformOnCartOrderSettledSubscriber,
    multi: true
  },
  {
    provide: PLATFORM_SUBSCRIBERS,
    useClass: PlatformOnAccountSelectedSubscriber,
    multi: true
  },
  {
    provide: PLATFORM_SUBSCRIBERS,
    useClass: PlatformOnCurrentWaiterUpdatedSubscriber,
    multi: true
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (subscribers: unknown[]) => () => {
      void subscribers;
    },
    deps: [PLATFORM_SUBSCRIBERS]
  }
];
